import React from 'react';
import styled from '@emotion/styled';
import {
  COLOR_GREEN,
  BREAKPOINT_SMALL,
} from 'client/components/MarketingPagesShared/styles';
import { useT } from 'client/i18n/hooks/useT';

const Section = styled.section`
  color: #97e0ce;
  background: ${COLOR_GREEN};
`;

const Container = styled.div`
  max-width: 880px;
  margin: 0 auto;
  padding: 132px 24px;
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    padding: 100px 24px;
  }
`;

const Heading = styled.h2`
  margin: 0 0 50px;
  font-weight: 900;
  font-size: 2.25rem;
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    font-size: 1.75rem;
  }
`;

const DefinitionList = styled.dl`
  width: 100%;
  max-width: 790px;
  font-size: 1rem;
`;

const DefinitionContainer = styled.div`
  margin-bottom: 30px;
  dt,
  dd {
    display: inline;
    line-height: 1.875rem;
  }
`;

export function Glossary() {
  const t = useT();

  const podcastAdDefinitions = [
    {
      term: 'SAI',
      definition: t(
        'AdsByAnchorScreen.Glossary.SAIDefinition',
        'Streaming Ad Insertion (SAI) is a podcast ad technology available on Spotify that unlocks digital planning, reporting, and measurement for podcast advertisers - based on confirmed ad impressions. Streaming Ad Insertion delivers the intimacy and quality of traditional podcast ads with the precision and transparency of modern day digital marketing.',
        'Ads by Anchor page glossary Section SAI definition'
      ),
    },
    {
      term: 'DAI',
      definition: t(
        'AdsByAnchorScreen.Glossary.DAIDefinition',
        'Dynamic Ad Insertion (DAI) is an ad technology. With DAI, ads are served through an ad server and are inserted upon receipt of a podcast file request. Spotify leverages DAI to serve our ads off-platform on non-Spotify podcast platforms like Apple Podcasts, Overcast, and Stitcher.',
        'Ads by Anchor page glossary Section DAI definition'
      ),
    },
    {
      term: 'SPAN',
      definition: t(
        'AdsByAnchorScreen.Glossary.SPANDefinition',
        'The Spotify Audience Network is Spotify’s proprietary audio advertising marketplace in which advertisers of all sizes will be able to connect with listeners consuming a broad range of content. These include Spotify’s Originals & Exclusives, podcasts via Megaphone and Anchor, and ad-supported music.',
        'Ads by Anchor page glossary Section SPAN definition'
      ),
    },
    {
      term: 'CPM',
      definition: t(
        'AdsByAnchorScreen.Glossary.CPMDefinition',
        'Cost per mille, a term used to denote the cost per 1000 impressions to the advertiser. This does not include the revenue share a platform may take.',
        'Ads by Anchor page glossary Section CPM definition'
      ),
    },
    {
      term: 'RPM',
      definition: t(
        'AdsByAnchorScreen.Glossary.RPMDefinition',
        'Revenue per mille, a term used to denote the earnings per 1000 impressions to you, the creator.',
        'Ads by Anchor page glossary Section RPM definition'
      ),
    },
  ];

  return (
    <Section>
      <Container>
        <Heading>
          {t(
            'AdsByAnchorScreen.Glossary.Title',
            'Podcast Ads Glossary:',
            'Ads by Anchor page glossary Section'
          )}
        </Heading>
        <DefinitionList>
          {podcastAdDefinitions.map(({ term, definition }) => {
            return (
              <DefinitionContainer key={term}>
                <dt>{term}</dt>
                <dd>
                  {` - `} {definition}
                </dd>
              </DefinitionContainer>
            );
          })}
        </DefinitionList>
      </Container>
    </Section>
  );
}
